var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOraichain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_323_8004)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_323_8004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2528 14.1654L14.2668 17.1603H11.9794L13.0523 14.1654H13.2528ZM18.7237 18.7638H17.0494V19.3534H21.1761V18.7638H19.5254V14.0475H21.1761V13.458H17.0494V14.0475H18.7237V18.7638ZM11.1894 19.3534L11.7553 17.7734H14.479L15.0096 19.3534H15.8821L13.7598 13.458H12.5571L10.3994 19.3534H11.1894ZM24.4657 24.9657H7.53427V8.03427H24.4657V24.9657Z",
    fill: "#1A1D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6507 32.5C25.2086 31.7218 31.2219 25.7085 32.0001 18.1507H30.0074C29.3 24.7063 24.3361 29.9296 17.6507 30.6724V32.5Z",
    fill: "#1A1D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.1507C0.778187 25.7085 6.79145 31.7218 14.3493 32.5V30.6724C7.66396 29.9296 2.71186 24.6945 1.99263 18.1507H0Z",
    fill: "#1A1D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 14.8493C31.2219 7.29145 25.2086 1.27819 17.6507 0.5V2.32756C24.3361 3.07038 29.2882 8.30545 30.0074 14.8493H32.0001Z",
    fill: "#1A1D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3493 0.5C6.79145 1.27819 0.778187 7.29145 0 14.8493H1.99263C2.70007 8.29367 7.66397 3.07038 14.3493 2.32756V0.5Z",
    fill: "#1A1D1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_323_8004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#1A1D1F",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_323_8004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#1A1D1F",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOraichain);
export default __webpack_public_path__ + "static/media/oraichain.54336be370756d8356be7858635470e8.svg";
export { ForwardRef as ReactComponent };